import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { VenPriceListAdapter } from './adapters/vendor-price-list.adapter';
import { VendorsPriceList } from './entities/vendor-price-list.entity';
import { VendorsPriceListRepository } from './repositories/vendor-price-list.repository';
import { VendorsPriceListController } from './vendors-price-list.controller';
import { VendorsPriceListService } from './vendors-price-list.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([VendorsPriceListRepository]),
  ],
  controllers: [VendorsPriceListController],
  providers: [VendorsPriceListService, VenPriceListAdapter]
})
export class VendorsPriceListModule {}
